import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, App, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
import { HkApiproviderProvider } from '../providers/hk-apiprovider/hk-apiprovider';
import { OneSignal, OSNotificationPayload } from '@ionic-native/onesignal';
import { Deeplinks } from '@ionic-native/deeplinks'
declare var window;
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  validEmail:any;
  rootPage: string = "HomePage";
  isLogin: boolean = false;
  loginuser:any;
  role:any;
  pages: Array<{title: string, component: any}>;

  apptoken = {"token":""};
  postData = {
    user_id:"",
    oneSignal_userId:"",
    oneSignal_pushToken:""
  };
  resposeData : any;
  allMessage:any;
  userDetails:any;
  creater_name:any;
  create_company:any;
  constructor( public platform: Platform,
              public app:App,
              public statusBar: StatusBar,
              public splashScreen: SplashScreen,
              public oneSignal:OneSignal,
              public authService: HkApiproviderProvider,
              public events: Events,
              private deeplinks: Deeplinks) {
    this.initializeApp();
    window.component = this;
    this.creater_name = "";
    this.events.subscribe('user:signedIn', (userEventData,time) => {
      const data = JSON.parse(localStorage.getItem('userData'));
      this.loginuser = data.userData.user_id;
      this.role = data.userData.role;
      this.isLogin = true;
      this.initializeApp();
     });

    this.apptoken.token = HkApiproviderProvider.gettoken();
    localStorage.setItem('appconfig', JSON.stringify(this.apptoken));
	if(localStorage.getItem('userData')){
		const data = JSON.parse(localStorage.getItem('userData'));
		this.loginuser = data.userData.user_id;
    this.role = data.userData.role;
    this.creater_name = data.userData.creater_name;
    this.create_company = data.userData.create_company;
    this.isLogin = true;
	}
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if(this.platform.is('android')){
        HomePage.userPlatform = 'android';
      } 
      if(this.platform.is('ios')){
        HomePage.userPlatform = 'ios';
      } 
      
      if(this.isCordovaAvailable){
        
        this.oneSignal.startInit('e733fd26-495f-4a4d-8aa0-bd5e2f940da8', '971388395089');
        this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
        this.oneSignal.handleNotificationReceived().subscribe(data => this.onPushReceived(data.payload));
        this.oneSignal.handleNotificationOpened().subscribe(data => this.onPushOpened(data.notification.payload));
        if(this.isLogin){
          this.oneSignal.getIds().then(identity => {
          this.oneSignalUpdate(identity.userId,identity.pushToken);
          });
        }
        this.oneSignal.endInit();
        
         this.statusBar.backgroundColorByHexString('#307722');
         this.splashScreen.hide();
      }
      
      this.deeplinks.routeWithNavController(this.nav, {
        '/home': HomePage
      }).subscribe((match) => {
        console.log('Successfully routed', match);
      }, (nomatch) => {
        console.warn('Unmatched Route', nomatch);
      });
    });
  }

  oneSignalUpdate(userId:string,pushToken:string){
    this.postData.oneSignal_userId = userId;
    this.postData.oneSignal_pushToken = pushToken;
    this.postData.user_id = this.loginuser;
    this.authService.postData(this.postData, "oneSignalUpdate").then((result) =>{
			this.resposeData = result;
      if (this.resposeData.success) {
        console.log("Success");
      } else {
        console.log("Error");
      }
		}, (err) => {
		});
  }

  onPushReceived(payload: OSNotificationPayload) {  
    if(this.isCordovaAvailable){
      if(payload.additionalData.noti_type =='notification'){
        this.nav.setRoot("NotiDetailsPage",{id:payload.additionalData.id});
      }
    }
  }  
  
  onPushOpened(payload: OSNotificationPayload) {  
    if(this.isCordovaAvailable){
      if(payload.additionalData.noti_type =='notification'){
        this.nav.setRoot("NotiDetailsPage",{id:payload.additionalData.id});
      }
    }
  }  

  isCordovaAvailable = () => {  
    if (!(<any>window).cordova) {  
        alert('This is a native feature. Please use a device');  
        return false;  
    }  
    return true;  
  }; 

  onclickCheckIn(){
    this.nav.setRoot("CheckInPage");
  }

  onclickNotification(){
    this.nav.setRoot("NotificationsPage");
  }
  
  onclickHome(){
    this.nav.setRoot("HomePage");
  }

  onclickMyProfile(){
	  this.nav.setRoot("MyProfilePage");
  }

  checkLogin(){
    if(localStorage.getItem('userData')){
      return true;
    }else{
      return false;
    }
  }

  onclickUserList(){
    this.nav.setRoot("UserlistPage");
  }

  onclickCountry(){
    this.nav.setRoot("CountryPage");
  }

  onclickCinema(){
    this.nav.setRoot("CinemaPage");
  }

  onclickDonateCategory(){
    this.nav.setRoot("DonateCategoryPage",{type:'add'});
  }

  onclickDonorList(){
    this.nav.setRoot("DonorListPage");
  }

  onclickSoldTicketList(){
    this.nav.setRoot("SoldTicketListPage");
  }

  onclickAbout(){
    this.nav.setRoot("AboutPage",{page:'about'});
  }

  onclickTermsConditions(){
    this.nav.setRoot("AboutPage",{page:'terms_conditions'});
  }

  logout(){
  	localStorage.removeItem('userData');
  	this.isLogin = false;
  	window.location.reload();
    this.nav.setRoot("LoginPage");
  }

  login(){
    this.nav.setRoot("LoginPage");
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts